$(document).on('click','.landing-store [data-zg-role="reset-filters"]',function(e){
	e.preventDefault();
	e.stopPropagation();
	var redir=$('.landing-store').data('redir');
	var country=$('#filter_Country select option:selected').val();
	var city=$('#filter_City select option:selected').val();
	var comoli=$('#filter_comoli select option:selected').val();
	if(country != '' && city != ''){
		if(comoli != ''){
			location.href=redir+'?Country='+country+'&City='+city+'&comoli='+comoli;
		}else{
			location.href=redir+'?Country='+country+'&City='+city;
		}
	}else{
		$('.msg-error').removeClass('hidden');
	}
});

window.onload = function() {

	const pageIdentifier = document.getElementById('sl-map-container'); 
	if (pageIdentifier) {
	
		// Seleziona gli elementi necessari
		const filterContainer = document.getElementById('sl-filter-container-mobile');
		const openButton = document.getElementById('open-filters-btn'); // <-- CAMBIA QUESTO ID con quello del tuo pulsante di apertura
		const closeButton = document.getElementById('close-filters-btn');
		const showButton = document.getElementById('show-result-stores');
		

		// Funzione per mostrare/nascondere il pannello
		function toggleFilters() {
			filterContainer.classList.toggle('is-open');
			document.body.classList.toggle('no-scroll');
		}

		// Aggiungi l'evento al pulsante di apertura
		if (openButton) {
			openButton.addEventListener('click', function(event) {
				event.preventDefault(); // Previene il comportamento di default (es. se è un link)
				toggleFilters();
			});
		}

		// Aggiungi l'evento al pulsante di chiusura
		if (closeButton) {
			closeButton.addEventListener('click', function() {
				toggleFilters();
			});
		}

		if (showButton) {
			showButton.addEventListener('click', function() {
				toggleFilters();
			});
		}


		// --- 1. Seleziona gli elementi ---
		const mapButton = document.querySelector('.view-store-locator a:first-child');
		const listButton = document.querySelector('.view-store-locator a:last-child');
		const mapContainer = document.getElementById('sl-map-container');
		const listContainer = document.getElementById('sl-stores-container');

		// --- 2. Gestisci il click sul pulsante "Map" ---
		mapButton.addEventListener('click', function (event) {
			event.preventDefault(); // Impedisce al link di ricaricare la pagina

			// Mostra la mappa e nascondi la lista
			mapContainer.style.display = 'block';
			listContainer.style.display = 'none';

			// Aggiorna la classe 'active'
			mapButton.classList.add('active');
			listButton.classList.remove('active');
		});

		// --- 3. Gestisci il click sul pulsante "List" ---
		listButton.addEventListener('click', function (event) {
			event.preventDefault(); // Impedisce al link di ricaricare la pagina

			// Nascondi la mappa e mostra la lista
			mapContainer.style.display = 'none';
			listContainer.style.display = 'block';

			// Aggiorna la classe 'active'
			listButton.classList.add('active');
			mapButton.classList.remove('active');
		});
	}
};